import { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '@reducers/index';
import { gridOptionModel } from '@models/gridModel';
import { IRegisteredKeywordType } from '@models/keyword/keywordModel';
import { KeywordResearch } from '@classes/options/grid/keyword/keywordSuggestion';
import { clickedKeyword } from '@reducers/keyword/keywordSuggestionSlice';
import { fetchKeywordDeleteAll, fetchRegisteredKeywordDelete } from '@reducers/keyword/thunk/suggestionThunk';
import GridAtom from '@components/atom/grid/grid';
import NoData from '@components/atom/noData';

const RegisteredBox = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { registerdKeywordList } = useSelector(({ keywordSuggestion }: RootState) => keywordSuggestion);

  const [gridData, setGridData] = useState<gridOptionModel<IRegisteredKeywordType>>(null);

  const gridOption = new KeywordResearch();

  // useEffect for set gridOption
  useEffect(() => {
    if (registerdKeywordList) {
      console.log('registerdKeywordList: ', registerdKeywordList);
      setGridData(gridOption.registeredOption(registerdKeywordList, onClickKeywordHandler, onClickDeleteHandler));
    } else {
      setGridData(null);
    }
  }, [registerdKeywordList]);

  // keyword 클릭시 searchText에 해당 키워드 입력하게하기
  const onClickKeywordHandler = useCallback(
    (keywordId, keyword) => {
      dispatch(clickedKeyword({ keyword }));
    },
    [dispatch, clickedKeyword]
  );

  // 삭제 버튼 클릭 시 해당 키워드 데이터 삭제요청 + 리스트 삭제처리
  const onClickDeleteHandler = useCallback(
    (keywordId, keyword) => {
      dispatch(
        fetchRegisteredKeywordDelete({
          userId: 'SS',
          keyword: keyword,
          reqType: 'del',
        })
      );
    },
    [dispatch, fetchRegisteredKeywordDelete]
  );

  // DeleteAll Handler TODO: 삭제버튼을 disable 처리해두기 registerdKeywordList가 null 일거나 length가 0일때
  const onClickDeleteAll = useCallback(() => {
    if (confirm('Are You Sure you want to delete all keywords found?')) {
      dispatch(
        fetchKeywordDeleteAll({
          userId: 'SS',
          keywordList: registerdKeywordList.map((item) => item.id),
        })
      );
    }
  }, [dispatch, registerdKeywordList, fetchKeywordDeleteAll]);

  return (
    <div className="research-registration">
      <div className="research-top">
        <button
          type="button"
          className="btn-s thr btn-delete-a"
          disabled={registerdKeywordList?.length > 0 ? false : true}
          onClick={onClickDeleteAll}
        >
          Delete All
        </button>
      </div>
      <div className="tb-basic-wrap">
        <div className="tb-basic-inner">{gridData ? <GridAtom {...gridData} height="610px" /> : <NoData />}</div>
      </div>
    </div>
  );
};

export default RegisteredBox;
